import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "添加标签", -1)

import { reactive, nextTick, ref, onMounted } from "vue";
import { ElInput } from "element-plus";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import "ckeditor5-custom-build/build/translations/ja";
import "ckeditor5-custom-build/build/translations/en";
import {
  ArticleSearchRequest,
  initArticleSearchRequest,
} from "@/api/apitypes/request/ArticleSearchRequest";
import { postSingleArticle } from "@/api/functions/home";
import { MyCustomUploadAdapterPlugin } from "@/functions/utils/Upload";


export default /*#__PURE__*/_defineComponent({
  __name: 'Ckeditor',
  props: {
  languageEdit: {
    type: Object as any,
    language: String,
    // uuid
    uuid: String,
    // タイトル
    title: String,
    // コンテンツ
    content: String,
    // タグ
    tags: Array<string>,
    // 削除フラグ
    deleteFlag: Boolean,
  },
},
  setup(__props) {

const props = __props;

const title = ref(props.languageEdit.title);

const langCk: string = props.languageEdit.language;

const edit = reactive({
  editor: Editor.Editor,
  editorData: "",
  editorConfig: {
    language: langCk === "zh" ? "" : langCk,
    toolbar: {
      shouldNotGroupWhenFull: true,
      mediaEmbed: true,
    },
    extraPlugins: [MyCustomUploadAdapterPlugin],
  },
});

// more settings
const inputValue = ref("");
const dynamicTags = ref(["Sample"]);
const inputVisible = ref(false);
const InputRef = ref<InstanceType<typeof ElInput>>();

const handleClose = (tag: string) => {
  dynamicTags.value.splice(dynamicTags.value.indexOf(tag), 1);
};

const showInput = () => {
  inputVisible.value = true;
  nextTick(() => {
    InputRef.value!.input!.focus();
  });
};

const handleInputConfirm = () => {
  if (inputValue.value) {
    dynamicTags.value.push(inputValue.value);
  }
  inputVisible.value = false;
  inputValue.value = "";
  onEditorBlur();
};

const onEditorBlur = () => {
  if (title.value !== "") {
    props.languageEdit.title = title.value;
  }

  if (edit.editorData !== "") {
    props.languageEdit.content = edit.editorData;
  }
  props.languageEdit.deleteFlag = false;
  props.languageEdit.tags = dynamicTags.value;
  props.languageEdit.language = props.languageEdit.language;
};

const getArticleHandle = (articleSearchRequest: ArticleSearchRequest) => {
  articleSearchRequest.theme = props.languageEdit.theme;
  postSingleArticle(articleSearchRequest).then((res) => {
    edit.editorData = res.data.content;
    title.value = res.data.title;
    dynamicTags.value = res.data.tags;
  });
};

onMounted(async () => {
  if (props.languageEdit.theme) {
    const articleSearchRequest: ArticleSearchRequest = initArticleSearchRequest(
      props.languageEdit.language
    );

    getArticleHandle(articleSearchRequest);
  }
  });

return (_ctx: any,_cache: any) => {
  const _component_ckeditor = _resolveComponent("ckeditor", true)!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElInput), {
      modelValue: title.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
      placeholder: "Please input title(Maxlength:16)",
      onBlur: onEditorBlur,
      maxlength: "16"
    }, null, 8, ["modelValue"]),
    _hoisted_1,
    _createVNode(_component_ckeditor, {
      editor: edit.editor,
      modelValue: edit.editorData,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((edit.editorData) = $event)),
      config: edit.editorConfig,
      onBlur: onEditorBlur
    }, null, 8, ["editor", "modelValue", "config"]),
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: "更多设置",
          name: "1"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dynamicTags.value, (tag) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: tag,
                class: "mx-1",
                closable: "",
                "disable-transitions": false,
                onClose: ($event: any) => (handleClose(tag)),
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag), 1)
                ]),
                _: 2
              }, 1032, ["onClose"]))
            }), 128)),
            (inputVisible.value)
              ? (_openBlock(), _createBlock(_unref(ElInput), {
                  key: 0,
                  ref_key: "InputRef",
                  ref: InputRef,
                  modelValue: inputValue.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputValue).value = $event)),
                  class: "ml-1 w-20",
                  size: "small",
                  onKeyup: _withKeys(handleInputConfirm, ["enter"]),
                  onBlur: handleInputConfirm
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  class: "button-new-tag ml-1",
                  size: "small",
                  onClick: showInput
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" + New Tag ")
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})